<div *ngIf="visible" class="alert alert-warning text-center" role="alert">
  <span *ngIf="message"> {{ message }} </span>
  <span *ngIf="!message"> Dados não encontrado. </span>
</div>